import { render, staticRenderFns } from "./comp_TaloCountdown.vue?vue&type=template&id=7dd2b040"
import script from "./comp_TaloCountdown.vue?vue&type=script&lang=js"
export * from "./comp_TaloCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports